import React, { useContext, useCallback, useRef, useState, memo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { history } from '../../history';
import { UserContext } from '../../context';
import { FiLogOut, FiSun, FiMoon } from 'react-icons/fi';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../styles.css';

const Menu = memo(() => {
  const context   = useContext(UserContext);
  const logado    = context.isLogger;
  const theme     = context.theme;
  const toggleTheme = context.toggleTheme;
  const userRole  = localStorage.getItem('user-role');
  const userName  = localStorage.getItem('user-name') || '';
  const isMaster  = userRole === 'MASTER';
  const location  = useLocation();

  // Easter egg — triple click no logo
  const logoClicksRef = useRef([]);
  const [logoSpin, setLogoSpin] = useState(false);
  const [toast, setToast]       = useState(null);

  const logout = useCallback(() => {
    localStorage.removeItem('delphireact-token');
    localStorage.removeItem('user-role');
    localStorage.removeItem('user-name');
    context.alterLogin(false);
    history.push('/login');
  }, [context]);

  const handleLogoClick = useCallback((e) => {
    e.preventDefault(); // sempre previne — navega manualmente se necessário
    const now = Date.now();
    logoClicksRef.current = [...logoClicksRef.current, now].filter(t => now - t < 700);
    if (logoClicksRef.current.length >= 3) {
      logoClicksRef.current = [];
      setLogoSpin(true);
      setToast(`🎉 Easter egg descoberto por ${userName || 'Usuário'}!`);
      setTimeout(() => setLogoSpin(false), 700);
      setTimeout(() => setToast(null), 3200);
    } else {
      history.push('/');
    }
  }, [userName]);

  if (!logado) return null;

  const initials = userName
    .split(' ')
    .slice(0, 2)
    .map(w => w[0])
    .join('')
    .toUpperCase() || 'U';

  const links = [
    { to: '/',           label: 'Home' },
    { to: '/pdv',        label: 'PDV' },
    { to: '/lics',       label: 'Licenças' },
    { to: '/ver',        label: 'Versões' },
    { to: '/csapi',      label: 'Produtos AZ' },
    ...(isMaster ? [
      { to: '/auditoria',     label: 'Auditar' },
      { to: '/update',        label: 'Update' },
      { to: '/classificacao', label: 'Classificação' },
    ] : []),
  ];

  return (
    <>
      {toast && <div className="ee-toast">{toast}</div>}

      <nav className="cs-navbar">
        {/* Brand — triple-click ativa easter egg */}
        <a className="cs-navbar-brand" href="/" onClick={handleLogoClick}>
          <div className={`cs-logo-icon${logoSpin ? ' ee-logo-spin' : ''}`}>C</div>
          <div>
            Compsoft
            <span className="cs-sub">Sistemas e Automação</span>
          </div>
        </a>

        <div className="cs-nav-divider cs-nav-divider-after-brand" />

        {/* Links de navegação — ocultos no mobile */}
        <ul className="cs-nav-links">
          {links.map(({ to, label }) => (
            <li key={to}>
              <Link
                className={`cs-link ${location.pathname === to ? 'active' : ''}`}
                to={to}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="cs-nav-divider" />

        {/* Toggle tema claro/escuro */}
        <button
          className="cs-theme-btn"
          onClick={toggleTheme}
          title={theme === 'dark' ? 'Mudar para tema claro' : 'Mudar para tema escuro'}
        >
          {theme === 'dark' ? <FiSun size={16} /> : <FiMoon size={16} />}
        </button>

        <div className="cs-nav-divider" />

        {/* Usuário + Sair */}
        <div className="cs-user-badge">
          <div className="cs-avatar">{initials}</div>
          <span className="cs-uname">{userName || 'Usuário'}</span>
        </div>

        <button
          className="cs-logout-btn ms-2"
          onClick={logout}
          title="Sair da aplicação"
        >
          <FiLogOut size={16} />
          <span className="cs-logout-label">Sair</span>
        </button>
      </nav>
    </>
  );
});

export default Menu;
